@if (isBusy) {
  <div class="flex flex-col items-center justify-center flex-1 px-8">
    @if (cadFileNames.length > 0) {
      <div class="text-sm font-medium mb-2 text-center">
        @for (cadFileName of cadFileNames; track $index) {
          <p>{{ cadFileName }}</p>
        }
      </div>
    }
    <p-progressbar class="w-full" [value]="progress" />
    <p class="text-muted-color mt-3 text-sm text-center">
      {{ statusText }}
    </p>
  </div>
} @else {
  <div class="flex-1 min-h-0 flex flex-col">
    <p-tabs
      class="flex-1 min-h-0 flex flex-col"
      [value]="activeTab"
      (valueChange)="setActiveTab($any($event))"
    >
      <p-tablist>
        <p-tab value="upload">Upload New CAD</p-tab>
        <p-tab value="existing">Use Existing CAD</p-tab>
      </p-tablist>

      <p-tabpanels class="flex-1 min-h-0">
        <p-tabpanel value="upload" class="h-full min-h-0">
          <app-upload-cad
            [multiple]="multiple"
            (filesSelected)="onFilesSelected($event)"
          />
        </p-tabpanel>

        <p-tabpanel value="existing" class="h-full min-h-0">
          <app-use-existing-cad
            [multiple]="multiple"
            [forMoulding]="false"
            (filesSelected)="onExistingCadFilesSelected($event)"
          />
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  @if (fileTypeError) {
    <p-message severity="error" styleClass="w-full mt-4">
      {{ fileTypeError }}
    </p-message>
  }

  @if (processingError) {
    <p class="text-sm text-red-500 mt-2">{{ processingError }}</p>
  }
}

<shared-confirm-dialog />
